import * as React from "react";
import Box from "@mui/material/Box";
import { Label } from "@fluentui/react/lib/Label";
import { EquipmentDropdown } from "@taskpane/components/ftl/EquipmentDropdown";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import type { TmsProviderCapabilities } from "@src/types/api";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";

const SHIPMENT_MODE_OPTIONS = ["LTL", "Truckload"];

const styles = {
  fieldWrap: {},
};

interface ShipmentDetailsModeEquipmentProps {
  state: LTLState;
  providerConfig: TmsProviderCapabilities;
  onShipmentModeChange: (mode: "LTL" | "Truckload") => void;
  onEquipmentChange: (equipment: string) => void;
}

export function ShipmentDetailsModeEquipment({
  state,
  providerConfig,
  onShipmentModeChange,
  onEquipmentChange,
}: ShipmentDetailsModeEquipmentProps): React.ReactElement | null {
  if (!providerConfig.requiresShipmentMode) return null;

  return (
    <>
      <Box sx={styles.fieldWrap}>
        <Label required>Shipment Mode</Label>
        <EquipmentDropdown
          value={state.shipmentMode}
          onChange={(val: string) => onShipmentModeChange(val as "LTL" | "Truckload")}
          options={SHIPMENT_MODE_OPTIONS}
        />
      </Box>
      {((state.shipmentMode === "Truckload" && providerConfig.requiresEquipmentForTruckload) ||
        (state.shipmentMode === "LTL" &&
          (providerConfig.ltlEquipmentOptions?.length ?? 0) > 0)) && (
        <Box sx={styles.fieldWrap}>
          <Label
            required={
              state.shipmentMode === "Truckload" && !!providerConfig.requiresEquipmentForTruckload
            }
          >
            Equipment
          </Label>
          <EquipmentDropdown
            value={state.equipment}
            onChange={onEquipmentChange}
            options={
              state.shipmentMode === "Truckload"
                ? providerConfig.ftlEquipmentOptions || []
                : providerConfig.ltlEquipmentOptions || []
            }
            errorMessage={state.errors.equipment}
            anchorId={ltlFieldInputId("equipment")}
          />
        </Box>
      )}
    </>
  );
}
